import React, { useEffect, useMemo, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { useTranslation } from "react-i18next";

export const SignaturePadField = ({ onChange }) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const wrapperRef = useRef(null);
  const [empty, setEmpty] = useState(true);
  const [dims, setDims] = useState({ width: 600, height: 180 });

  useEffect(() => {
    const updateSize = () => {
      if (wrapperRef.current) {
        const w = wrapperRef.current.offsetWidth;
        setDims({ width: w, height: 180 });
      }
    };
    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  // Memoize canvasProps so SignatureCanvas doesn't see a new object every render
  const canvasProps = useMemo(
    () => ({ width: dims.width, height: dims.height, className: "w-full h-[180px]" }),
    [dims.width, dims.height]
  );

  const handleEnd = () => {
    if (ref.current && !ref.current.isEmpty()) {
      const data = ref.current.toDataURL("image/png");
      setEmpty(false);
      onChange?.(data);
    }
  };

  const clear = () => {
    ref.current?.clear();
    setEmpty(true);
    onChange?.(null);
  };

  return (
    <div data-testid="signature-pad">
      <div ref={wrapperRef} className="sig-pad relative overflow-hidden">
        <SignatureCanvas
          ref={ref}
          penColor="#2C2A29"
          canvasProps={canvasProps}
          onEnd={handleEnd}
        />
        {empty && (
          <div className="pointer-events-none absolute inset-0 flex items-center justify-center text-[#8C7A6B] text-sm font-serif italic">
            {t("checkout.sign_here")}
          </div>
        )}
      </div>
      <div className="flex items-center justify-between mt-2">
        <button type="button" onClick={clear} data-testid="signature-clear-btn"
                className="text-xs text-[#8C7A6B] hover:text-[#C86D53] transition-colors">
          {t("checkout.clear")}
        </button>
        {!empty && <span className="text-xs text-[#C86D53]">✓ {t("checkout.signed")}</span>}
      </div>
    </div>
  );
};
